// Runtime list of apps as the single source of truth. Use `as const` so the
// literal values are preserved at the type level and can be used to derive
// the `AppType` union below.
export const APPS = ['CXP', 'PAYFINE', 'DRIVERABSTRACT'] as const;

export type AppType = (typeof APPS)[number];

export type AdminMessage = {
    app?: AppType;
    id?: string;
    messageContent?: string;
    messageType?: string;
    messageContentFrench?: string;
    isActive?: boolean;
    fromTime?: string;
    toTime?: string;
    userId?: string;
    reason?: string;
};
